export class DocumentDbSnapshotProperties {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "recoveryPointArn",
            "baseName": "recoveryPointArn",
            "type": "string",
            "format": ""
        },
        {
            "name": "backupVaultName",
            "baseName": "backupVaultName",
            "type": "string",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "sourceAccountId",
            "baseName": "sourceAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "clusterIdentifier",
            "baseName": "clusterIdentifier",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DocumentDbSnapshotProperties.attributeTypeMap;
    }
    constructor() {
    }
}
